import { SALLIE_MAE_PRODUCT_IDS } from '../constants/Strings';
var getIsSallieMaeProduct = function getIsSallieMaeProduct(productId) {
  return !!productId && SALLIE_MAE_PRODUCT_IDS.has(productId);
};
export default getIsSallieMaeProduct;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getIsSallieMaeProduct.js
// module id = 4132
// module chunks = 11